<template>
    <div class="ui-search-suggestions custom-scroll flex flex-column items-start">
        <UIButton
            v-for="(suggestion, index) in suggestions"
            :key="`suggestion__${index}`"
            flat
            class="ui-search-suggestions__item"
            @click="$emit('change', suggestion)"
        >
            <span
                class="ui-search-suggestions__item__label"
                v-html="suggestion.label"
            />
            <slot
                name="suggestion"
                :suggestion="suggestion"
            />
        </UIButton>
    </div>
</template>

<script>
import {defineComponent} from 'vue';
import {UIButton} from '@cibsite/ui-components-vue2';

export default defineComponent({
    name: 'UISearchSuggestions',
    components: {
        UIButton,
    },
    props: {
        suggestions: {
            type: Array,
            default: () => ([]),
        },
    },
});
</script>
